module.exports = __webpack_public_path__ + "img/m-icon6.7f3c1e45.png";